import React from 'react'

const PauseIcon = ({
  width = 108,
  height = 108,
  color = '#299D6B',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 108 108"
    fill="none"
    {...props}
  >
    <rect width={108} height={108} rx={54} fill="white" />

    {/* Outer Circle */}
    <circle cx="54" cy="54" r="45" fill={color} />

    {/* Pause Bars */}
    <rect x="40" y="36" width="8" height="36" rx="2" fill="white" />
    <rect x="60" y="36" width="8" height="36" rx="2" fill="white" />
  </svg>
)

export default PauseIcon
